import { payableCurrencySymbols } from "./currency-symbols";
import { scope3CategoriesCache } from './scope3-categories.cache';

export const SUPPLIER_SUMMARY_GRID_DATA = {
    endpoint: '/organization/%organizationId%/report',
    columnDefinitions: [
        {
            title: 'Supplier',
            data: 'supplierName',
            orderable: true,
            searchable: false,
            render: (data, type, row, meta) => {
                let content = '<td><div><span>';
                content += '<span style="display: inline-block;"><div data-toggle="popover" data-title="';
                content += (data !== null && data !== 'tbd') ? data : '';
                content += '" data-content="<div>';
                content += (row['address']['city'] && row['address']['city'] !== 'tbd') ? row['address']['city'] : '';
                content += '</div><div>';
                content += (row['address']['country'] && row['address']['country'] !== 'tbd') ? row['address']['country'] : '';
                content += '</div><div>';
                content += row['industryName'];
                content += '</div>" data-placement="right" data-html="true" data-trigger="hover">';
                content += data;
                content += '</div></span>';

                return content;
            }
        },
        {
            title: 'Amount',
            data: 'amount',
            orderable: true,
            searchable: false,
            render: (data, type, row, meta) => {
                const currencySymbol = payableCurrencySymbols[row.currency];
                return currencySymbol + ' ' + parseFloat(data).toFixed(2);
            }
        },
        {
            title: 'Currency',
            data: 'currency',
            orderable: false,
            searchable: false,
            visible: false
        },
        {
            title: 'Industry',
            data: 'industryName',
            orderable: true,
            searchable: false
        },
        {
            title: 'Total tCO2e',
            data: 'allScopesTotal',
            orderable: true,
            searchable: false,
            render: (data, type, row, meta) => {
                return parseFloat(data).toFixed(4);
            }
        },
        {
            title: 'Scope 1 tCO2e',
            data: 'scope1Total',
            orderable: true,
            searchable: false,
            render: (data, type, row, meta) => {
                return parseFloat(data).toFixed(4);
            }
        },
        {
            title: 'Scope 2 tCO2e',
            data: 'scope2Total',
            orderable: true,
            searchable: false,
            render: (data, type, row, meta) => {
                return parseFloat(data).toFixed(4);
            }
        },
        {
            title: 'Scope 3 tCO2e',
            data: 'scope3Total',
            orderable: true,
            searchable: false,
            render: (data, type, row, meta) => {
                return parseFloat(data).toFixed(4);
            }
        },
        {
            title: 'Category',
            data: 'scope3Category',
            orderable: true,
            searchable: false,
            render: (data, type, row, meta) => {
            
            const current = row['scope3Category']? row['scope3Category']['id'] : '';
            
            const options = scope3CategoriesCache.list
            .map(c => {
                const selected = String(c.id) === String(current) ? ' selected' : '';
                return '<option value="' + c.id + '" ' +  selected + '>' + c.name + '</option>';
            })
            .join('');

            let content = '<span id=';
            content += 'scope3-category#' + meta['row'] + '#' + meta['col'] + '>'
            content += row['scope3Category']['name'] + '</span>';
            content += '<select class="form-control form-control-sm" id="' + 'scope3-category-select#' + meta['row'] + '#' + meta['col']  + '" style="display:none">' + options + '</select>'
            return content;

            }
        },
        {
            title: '',
            data: 'transactionId',
            orderable: false,
            searchable: false,
            visible: false
        },
        {
          title: 'Edit?',
          searchable: false,
          orderable: false,
          render: (data, type, row, meta) => {
            let content = '<span><i id="cell-event#scope3-category-edit#' + meta['row'] + '#' + meta['col'] +
              '" class="fa fa-edit" style="font-size:18px; cursor:pointer; color:#3498DB; padding:0 4px;" title="Edit"></i></span>';
            content += '<span><i id="cell-event#scope3-category-confirm#' + meta['row'] + '#' + meta['col'] +
            '" class="fa fa-check" style="display: none; font-size:18px; cursor:pointer; color:#3498DB; padding:0 4px;" title="Confirm"></i></span>';
            content += '<span><i id="cell-event#scope3-category-clear#' + meta['row'] + '#' + meta['col'] +
            '" class="fa fa-remove" style="font-size:18px; cursor:pointer; color:#3498DB; padding:0 4px;" title="Restore guess"></i></span>';
            return content;
          }
      }
    ],
    dataSrc: {
        recordsTotalAlias: 'totalSuppliers',
        recordsFilteredAlias: 'filteredSuppliers',
        recordsAlias: 'suppliers'
    },
    queryDefinition: {
        type: 'supplierSummary'
    },
    defaultSortColumn: 'amount',
    defaultSortOrder: 'desc',
    sortCriteriaMap: {
        supplierName: 'supplierName',
        amount: 'amount',
        currency: 'currency',
        industryName: 'industryName',
        allScopesTotal: 'allScopesTotal',
        scope1Total: 'scope1Total',
        scope2Total: 'scope2Total',
        scope3Total: 'scope3Total',
        scope3Category: 'scope3Category'
    },
    editFieldPrefixes: [
     {
        label: 'scope3-category-confirm',
        isControl: true,
        handler: (row, col) => {
            const scope3CategorySelectSelector = 'scope3-category-select#' + row + '#8';
            const scope3CategorySelectSelectorElement = document.getElementById(scope3CategorySelectSelector) as HTMLSelectElement;
            const scope3CategoryValue = scope3CategorySelectSelectorElement.value;
            const selectedIndex = scope3CategorySelectSelectorElement.selectedIndex;
            const scope3CategoryText = scope3CategorySelectSelectorElement.options[selectedIndex].text;
            scope3CategorySelectSelectorElement.style.display = 'none';

            const scope3CategorySelector = 'scope3-category#' + row + '#8';
            const scope3CategorySelectorElement = document.getElementById(scope3CategorySelector);
            scope3CategorySelectorElement.innerHTML = scope3CategoryText;
            scope3CategorySelectorElement.style.display = 'block';

            // Show the edit element
            const productEditSelector = 'cell-event#scope3-category-edit#' + row + '#' + col;
            document.getElementById(productEditSelector).style.display = 'inline';

            // Hide the confirm element
            const productConfirmSelector = 'cell-event#scope3-category-confirm#' + row + '#' + col;
            document.getElementById(productConfirmSelector).style.display = 'none';

            return { scope3TransactionCategoryId: scope3CategoryValue };
        },
        ioEvent: 'modifyTransacton',
        ioIndices: {
          transactionIdIdx: 9,
          scope3TransactionCategoryIdIdx: 8
        }
        
      },
      {
        label: 'scope3-category-edit',
        isControl: true,
        handler: (row, col) => {

          // The category is column index 8
          const scope3CategorySelector = 'scope3-category#' + row + '#8';
          document.getElementById(scope3CategorySelector).style.display = 'none';
          const scope3CategorySelectSelector = 'scope3-category-select#' + row + '#8';
          document.getElementById(scope3CategorySelectSelector).style.display = 'block';

          // Show the confirm element
          const scope3CategoryConfirmSelector = 'cell-event#scope3-category-confirm#' + row + '#' + col;
          document.getElementById(scope3CategoryConfirmSelector).style.display = 'inline';

          // Hide the edit element
          const scope3CategoryEditSelector = 'cell-event#scope3-category-edit#' + row + '#' + col;
          document.getElementById(scope3CategoryEditSelector).style.display = 'none';
        }
      },
      {
        label: 'scope3-category-clear',
        isControl: true,
        handler: (row, col) => {

            let confirmationMsg = confirm("You are about to remove your transaction edits.  This will default to the original guess.  Are you sure?");

            if(confirmationMsg){
                // The category is column index 8
                const scope3CategorySelector = 'scope3-category#' + row + '#8';
                document.getElementById(scope3CategorySelector).style.display = 'block';
                const scope3CategorySelectSelector = 'scope3-category-select#' + row + '#8';
                document.getElementById(scope3CategorySelectSelector).style.display = 'none';

                // Hide the confirm element
                const scope3CategoryConfirmSelector = 'cell-event#scope3-category-confirm#' + row + '#' + col;
                document.getElementById(scope3CategoryConfirmSelector).style.display = 'none';

                // Show the edit element
                const scope3CategoryEditSelector = 'cell-event#scope3-category-edit#' + row + '#' + col;
                document.getElementById(scope3CategoryEditSelector).style.display = 'inline';
            }
            
        },
      },
    ]
};
